import { Pagination as PaginationAnt } from 'antd';
import styled from 'styled-components/macro';

export const Pagination = styled(PaginationAnt)`
  display: flex;
  justify-content: center;
  margin-top: 40px !important;
  margin-bottom: 40px !important;
`;
